/**
 * Site aliases in SFCC URLs (`app.siteAliases`, e.g. `/us/en/...`), shared by the app (`coreUtils/url`) and the
 * Express server. No path aliases here: also imported by the server.
 */

/**
 * Removes the site alias prefixes from an SFCC path (`/{alias}/en/...` → `/en/...`).
 * @param {string} path - SFCC path
 * @param {Record<string, string>} siteAliases - `app.siteAliases`, alias by site id
 * @returns {string}
 */
export const removeSiteAliasPrefix = (path: string, siteAliases: Record<string, string> = {}): string => {
	let updatedPath = path;

	Object.values(siteAliases).forEach((alias) => {
		if (updatedPath) {
			updatedPath = updatedPath.replace(`/${alias}/`, '/');
		}
	});

	return updatedPath;
};
